module.exports = __webpack_public_path__ + "img/76016.58ec1ba5.svg";